export const features = (state) => state.features;

export const featuresByTenant = (state) => state.featuresByTenant;

export const getIfTimelineEnabled = (state) => state.timelineEnabled;
